import React, { memo } from 'react';
import { SnackbarProvider } from 'notistack';

import { MAX_SNACKS } from '../constants';
import ErrorNotification from './ErrorNotification';
import SuccessNotification from './SuccessNotification';
import WarningNotification from './WarningNotification';

const NotificationsProvider = ({ children }) => {
  return (
    <SnackbarProvider
      maxSnack={MAX_SNACKS}
      anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
      Components={{
        error: ErrorNotification,
        success: SuccessNotification,
        warning: WarningNotification,
      }}>
      {children}
    </SnackbarProvider>
  );
};

export default memo(NotificationsProvider);
